/**
 * This module contains search factories for use with the FlyFreely tables.
 */

import * as moment from 'moment';

/**
 * Search function factory for a date range. This range is expected to already be normalised
 * to the timezone.
 */
export function dateRange(range: [Date, Date]) {
    const start = range[0];
    const end = range[1];

    return (date: moment.Moment) =>
        date ? date.isBetween(start, end, undefined, '[]') : false;
}

export function isInArray(value: any) {
    return (array: any[]) => array != null && array.indexOf(value) !== -1;
}
